export default __webpack_public_path__ + "static/media/BrandingLabel.8581909d.png";